import React, {useState} from 'react';
import Buttons, {EnumButtonType, EnumColors} from "../../../../components/Utils/Buttons/Buttons/Buttons";
import styles from './DemoNotAuthorized.module.css'
import {EnumFog} from "../../../../components/Utils/FogContainer/FogContainer";
import Authentication from "../../../../components/Authentication/Authentication";
import ModalPortal from "../../../../Portals/ModalPortal";
import LayoutContentWrapper from "../../../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ImageForHorizon from "../../../../components/Utils/Images/ImageForHorizon/ImageForHorizon";
import imageNotAuth from '../../../../uploads/images/demoNotAuth.jpg'
import {UIText} from "../../../../enums/UIText/UIText";
import {useAppSelector} from "../../../../hooks/redux";
import {getLanguage} from "../../../../store/selectors/appSelector";
import {getTextByLanguage} from "../../../../enums/utils/getTextByLanguage";
import { UXDemo } from '../../../../enums/UXText/UXDemo';

const DemoNotAuthorized = () => {

    const language = useAppSelector(getLanguage)

    const [isOpenLoginModal, setIsOpenLoginModal] = useState(false)

    return (
        <>
            <ImageForHorizon blurhash={'QFGIAJNG02oy~VE29a%1%2krRkE2af-:WCIVazxuD*f6xsRkRkkCayRkof'} src={imageNotAuth} alt={''} />
            <LayoutContentWrapper>
                <div className={styles.wrapper}>
                    <p>{getTextByLanguage(UXDemo.needAuthorization, language)}</p>
                    <Buttons onClick={() => setIsOpenLoginModal(true)} color={EnumColors.gold} type={EnumButtonType.filled}
                             className={styles.loginButton}>
                        {getTextByLanguage(UIText.authentication.buttons.login, language)}
                    </Buttons>

                    <ModalPortal options={{
                        setStateModal: setIsOpenLoginModal,
                        fogPower: EnumFog.veryStrong,
                        statusModal: isOpenLoginModal
                    }}>
                        <Authentication isOpenLoginModal={isOpenLoginModal}/>
                    </ModalPortal>
                </div>
            </LayoutContentWrapper>
        </>

    );
};

export default DemoNotAuthorized;